@if (error$ | async; as error) {
  <div class="alert alert-danger base-page-alert" role="alert">
    <div class="alert-icon">
      <span class="material-icons">error</span>
    </div>
    <div class="alert-message" style="flex:2">
      {{ error }}
    </div>
    <div>
      <button [attr.aria-label]="'aria.dismiss' | translate"  mat-icon-button
        (click)="onDismiss()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>
}

@if (errorMessage) {
  <div class="alert alert-danger base-page-alert" role="alert">
    <div class="alert-icon">
      <span class="material-icons">error</span>
    </div>
    <div class="alert-message" style="flex:2">
      {{ errorMessage }}
    </div>
    <div>
      <button [attr.aria-label]="'aria.dismiss' | translate" mat-icon-button
        (click)="onErrorDismiss()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>
}
